import { cubicBezier, transform, type Variant } from 'framer-motion';

const calcTimeForBombFrame = transform([0, 2], [0, 1]);

const transitionTimes = [0, 0.5, 1, 1.3, 1.5, 2].map((time) =>
  calcTimeForBombFrame(time),
);

const startBombAnimationVariant: Variant = {
  width: [null, 227, 227, 263, 263, 169],
  transition: {
    duration: 2,
    ease: [
      cubicBezier(0, 1, 1, 1),
      'linear',
      cubicBezier(1, 0, 1, 1),
      'linear',
      cubicBezier(0, 1, 1, 1),
    ],
    times: transitionTimes,
  },
};

const endBombAnimationVariant: Variant = {
  width: [null, 125, 125, 500],
  transition: {
    duration: 0.8,
    times: [0, 0.375, 0, 75, 1],
    ease: [cubicBezier(0, 0, 0.58, 1), 'linear', 'easeOut'],
  },
};

export { endBombAnimationVariant, startBombAnimationVariant };
